export default '0.2.23'
